// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__399_g","top":"styles_top__1Z1ZB","left":"styles_left__2MIaB","description":"styles_description__3wuO4"};